import { useState } from 'react';
import { Box, IconButton, Image } from '@chakra-ui/react';
import { MdOutlineMenu } from 'react-icons/md';
import { Container } from '../layout';
import Logo from '../logo';
import { MainMenu, SideMenu } from './main-menu';
import Actions from './actions';
import { Desktop, Mobile } from '../visual';
import { useOnlyClient } from '@/hooks/use-only-client';
import TypeWriter from '../type-writer';
import { Link } from 'react-router-dom';

function YaldaTopBanner() {
  return (
    <Link to="/product?tags=yalda">
      <Box width={'100vw'}>
        <Image
          src="/assets/campaigns/yalda/top-banner.png"
          height={'40px'}
          objectFit={'cover'}
          width={'100vw'}
          objectPosition={'left'}
          backgroundColor={'black'}
          position={'absolute'}
        />
        <TypeWriter
          strings={[
            'تخفیف های ویژه یلدا رو از دست نده!',
            'ارسال رایگان به سراسر کشور تا آخر آذر!',
          ]}
          color={'white'}
          fontSize={'20px'}
          fontWeight={'bold'}
          top={'5px'}
          position={'absolute'}
          textAlign={'center'}
          zIndex={1}
          options={{
            delay: 50,
            deleteSpeed: 30,
          }}
        />
      </Box>
    </Link>
  );
}

function Header() {
  const [sidemenuOpen, setSidemenuOpen] = useState(false);
  const render = useOnlyClient();
  return (
    <>
      {/* <YaldaTopBanner /> */}
      <header>
        <Container
          display={'flex'}
          alignItems={'center'}
          pt={'20px'}
          boxSizing="content-box"
        >
          <Desktop>
            <Logo />
            <Box mr={'56px'} />
            <MainMenu />
          </Desktop>
          <Mobile>
            <IconButton
              aria-label="menu icon"
              onClick={() => setSidemenuOpen(true)}
              variant={'ghost'}
              rounded={'full'}
              fontSize={'3xl'}
            >
              <MdOutlineMenu />
            </IconButton>
            <SideMenu
              open={sidemenuOpen}
              onClose={() => setSidemenuOpen(false)}
            />
          </Mobile>
          {render && <Actions />}
        </Container>
      </header>
    </>
  );
}

export default Header;
